export default "__VITE_ASSET__58f666e7__"